enum ApplicationWorkflowSetupTab {
  ProcessingStatuses = 'Processing Statuses',
  FinalStatuses = 'Final Statuses',
}

export default ApplicationWorkflowSetupTab;
